import { Package } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { UvivaPage } from './UvivaPage'

export default defineModule({
  id: 'uviva',
  name: 'Uviva Portal',
  shortName: 'Uviva',
  icon: Package,
  navSection: 'vendors',
  navOrder: 10,
  urlNamespace: '/uviva',
  routes: [
    { path: '/', element: UvivaPage, label: 'Uviva Portal' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'uviva', 'regulatory', 'finance'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',
  keyboardShortcut: 'g w',

  commandPaletteEntries: [
    {
      label: 'Uviva Portal',
      keywords: ['uviva', 'vendor', 'portal', 'submissions'],
      path: '/?tab=submissions',
      group: 'modules',
      shortcut: 'g w',
    },
    {
      label: 'Uviva — Submissions',
      keywords: ['uviva', 'submissions', 'shipment', 'cofa', 'receipt'],
      path: '/?tab=submissions',
      group: 'modules',
    },
    {
      label: 'Uviva — Inventory',
      keywords: ['uviva', 'inventory', 'uvwh', 'stock', 'lot'],
      path: '/?tab=inventory',
      group: 'modules',
    },
    {
      label: 'Uviva — Operations',
      keywords: ['uviva', 'operations', 'customer orders', 'samples', 'delivery', 'demand'],
      path: '/?tab=operations',
      group: 'modules',
    },
  ],
})
